import React from "react";
import classes from "./Table.module.css";
import { getData } from "app/data";

const TableComponent = props => {
  const tableData = getData(props.id);
  const tableTitle = tableData.tableTitle;
  const tableContents = tableData.tableContents;

  return (
    <div>
      <table className={classes.table}>
        <tr className={classes["table-row-title"]}>
          <th>{tableTitle.col1}</th>
          <th>{tableTitle.col3}</th>
          <th>{tableTitle.col2}</th>
        </tr>

        {tableContents.map(row => (
          <tr className={classes["table-row"]}>
            <td>{row.content.col1}</td>
            <td>{row.content.col3}</td>
            <td>{row.content.col2}</td>
          </tr>
        ))}
      </table>
    </div>
  );
};

export default TableComponent;
